import { ArticleMeta, articleTag } from "./types";

const META: ArticleMeta = {
    slug: "platform-modernization-program",
    section: "portfolio",
    header: "Payments",
    title: "Scaling A Global Payments Platform",
    description: "Fragile monolith releases replaced by service boundaries, typed contracts, automated deploys.",
    tags: [
        articleTag("aws.svg"),
        articleTag("docker.svg"),
        articleTag("kubernetes.svg"),
        articleTag("terraform.svg"),
        articleTag("visa-svgrepo-com.svg"),
    ],
    url: "/articles/platform-modernization-program",
};

export default META;
